import { Trophy } from "lucide-react";

import { Badge, ListRow, type BadgeKind } from "@/ui";
import { formatEventDate } from "@/lib/format";
import type { MyTournamentItem, MyTournamentResult } from "@/features/queries";

const RESULT_LABEL: Record<Exclude<MyTournamentResult, null>, string> = {
  winner: "1 место",
  finalist: "Призёр",
  participant: "Участник",
  in_progress: "Идёт",
  registered: "Записан",
};

const RESULT_KIND: Record<Exclude<MyTournamentResult, null>, BadgeKind> = {
  winner: "brand",
  finalist: "success",
  participant: "neutral",
  in_progress: "brand",
  registered: "neutral",
};

interface Props {
  tournament: MyTournamentItem;
  onClick?: () => void;
}

export function MyTournamentRow({ tournament, onClick }: Props) {
  const subtitleParts = [
    formatEventDate(tournament.date),
    tournament.spot_name,
  ].filter(Boolean) as string[];

  return (
    <ListRow
      leading={
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "var(--bg)",
            border: "1px solid var(--separator)",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--brand-orange)",
          }}
        >
          <Trophy size={18} strokeWidth={1.75} />
        </div>
      }
      title={tournament.name}
      subtitle={subtitleParts.join(" · ")}
      trailing={
        tournament.result ? (
          <Badge kind={RESULT_KIND[tournament.result]}>
            {RESULT_LABEL[tournament.result]}
          </Badge>
        ) : undefined
      }
      onClick={onClick}
    />
  );
}
